import { AxiosInstance } from "axios";
import { IContent } from "./interfaces";

export function getHeaderProfilesBuilder(apiClient: AxiosInstance) {
  return async function getHeaderProfiles(): Promise<IContent.HeaderProfileResponse | null> {
    try {
      const response = await apiClient.get("/v2/headers/");
      return response.data;
    } catch (error) {
      return null;
    }
  };
}
